import styled from "styled-components";

const DashboardDetailWrapper = styled.div`
  max-width: 420px;
  width: 100%;
`;

export { DashboardDetailWrapper };
